import { defineStyleConfig } from "@chakra-ui/react";

export const TextAreaStyle = defineStyleConfig({
    variants:{
        InputModalTextArea:{
            fontFamily:"poppins",
            border:"1px #E2E8F0 solid"
        }
    }
})